<section class="video-sec white c2">
  <div class="container c2">
    <div class="title c2">
      <small>{{ miniTitle[lang]?.[game] || miniTitle['en'][game] }}</small>
      <h2>{{ game === 'lol' || game === 'valorant' ? (title.play[lang] || title.play['en']) : (title.howTo[lang] || title.howTo['en']) }}</h2>
      <p>
        {{ description[lang]?.[game] || description['en'][game] }}
        <br>
        {{ description2[lang]?.[game] || description2['en'][game] }}
      </p>
    </div>
    <div *ngIf="requestDone" class="frame c2">
      <img class="layout-frame pc c2" [lazyLoad]="'https://cdn.ggboost.com/images/laptop.webp'" alt="laptop video viewer" />
      <img class="layout-frame mb c2" [lazyLoad]="'https://cdn.ggboost.com/images/phone.webp'" alt="phone video viewer" />
      <div class="video-frame c2">
        <!--<lite-youtube videoid="yA2Myf4R8BU" style="background-image: url('https://i.ytimg.com/vi/yA2Myf4R8BU/sddefault.jpg');
        height: 100%; max-width: unset;" playlabel="Tutorial: GGBoost"></lite-youtube>-->
        <app-lite-youtube [videoid]="lolVideoId" [playlabel]="lolVideoTitle" [style]="'height: 100%;'"></app-lite-youtube>
      </div>
      <a href="https://www.youtube.com/@ggboostcom" target="_blank">
        {{ 'view_more_on' | translate: lang }} Youtube</a>
    </div>
  </div>
</section>